<template>
    <div class="module-edit">
        <b-tabs
            class="management-module-tab apprentice-tab"
            content-class="management-module-tab-content">
            <b-tab
                :title="$t('modules.details')"
                active>
                <div class="apprentice-simple-card">
                    <design-2021-module-management-edit-overall-component
                        :tags-in="tagsIn"
                        :education-levels-in="educationLevelsIn"
                        :module-in="moduleIn"
                        :skill-trees-in="skillTreesIn"
                        :teachers-in="allTeachersIn"
                        :las-groups-in="lasGroupsIn">
                    </design-2021-module-management-edit-overall-component>
                </div>
            </b-tab>

            <b-tab :title="$t('modules.schedule')">
                <div class="apprentice-simple-card">
                    <design-2021-module-managment-edit-date-component
                        :module-in="moduleIn"
                        :module-periods-in="modulePeriodsIn"></design-2021-module-managment-edit-date-component>
                </div>
            </b-tab>

            <b-tab :title="$t('modules.participants')">
                <div class="apprentice-simple-card">
                    <design-2021-module-management-edit-participant-component
                        :module-in="moduleIn"
                        :module-periods-in="modulePeriodsIn"></design-2021-module-management-edit-participant-component>
                </div>
            </b-tab>

            <b-tab :title="$t('modules.skills')">
                <div class="apprentice-simple-card">
                    <design-2021-module-management-edit-survey-component :module-id-in="moduleIn.id">
                    </design-2021-module-management-edit-survey-component>
                </div>
            </b-tab>

            <b-tab :title="$t('modules.access')">
                <div class="apprentice-simple-card">
                    <design-2021-module-management-edit-access-component
                        :las-groups-in="lasGroupsIn"
                        :las-main-groups-in="lasMainGroupsIn"
                        :module-in="moduleIn"></design-2021-module-management-edit-access-component>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: 'design-2021-module-management-edit-component',
    props: [
        'moduleIn',
        'tagsIn',
        'educationLevelsIn',
        'allTeachersIn',
        'skillTreesIn',
        'lasGroupsIn',
        'lasMainGroupsIn',
        'modulePeriodsIn',
    ],
};
</script>

<style scoped></style>
